// SPDX-License-Identifier: AGPL-3.0-or-later

import {UserTag} from '@app/features/channel/components/UserTag';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import styles from '@app/features/user/components/profile/profile_card/ProfileCardUserInfo.module.css';
import type {User} from '@app/features/user/models/User';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface ProfileCardUserInfoProps {
	displayName: string;
	user: User;
	pronouns?: string | null;
	showUsername?: boolean;
	isClickable?: boolean;
	isWebhook?: boolean;
	onDisplayNameClick?: () => void;
	onUsernameClick?: () => void;
	actions?: React.ReactNode;
	usernameActions?: React.ReactNode;
}
export const ProfileCardUserInfo: React.FC<ProfileCardUserInfoProps> = observer(
	({
		displayName,
		user,
		pronouns,
		showUsername = true,
		isClickable = true,
		isWebhook = false,
		onDisplayNameClick,
		onUsernameClick,
		actions,
		usernameActions,
	}) => {
		return (
			<div className={styles.userInfoContainer}>
				<div className={styles.nameRow}>
					<FocusRing offset={-2}>
						<button
							type="button"
							onClick={onDisplayNameClick}
							className={clsx(styles.nameButton, isClickable && styles.nameButtonClickable)}
						>
							{displayName}
						</button>
					</FocusRing>
					<div className={styles.badgeContainer}>
						{(user.bot || isWebhook) && <UserTag className={styles.userTagWrapper} system={user.system} />}
					</div>
					{actions && <div className={styles.actionsContainer}>{actions}</div>}
				</div>
				{showUsername && (
					<div className={styles.usernameRow}>
						<FocusRing offset={-2}>
							<button type="button" onClick={onUsernameClick} className={styles.usernameButton}>
								{user.tag}
							</button>
						</FocusRing>
						{usernameActions}
					</div>
				)}
				{pronouns && <div className={styles.pronouns}>{pronouns}</div>}
			</div>
		);
	},
);
